<script>
import RealignmentItems from "@/components/tables/realignment-items.vue";
import RawData from "@/components/widgets/raw-data.vue";
import { groupBy } from "lodash";
export default {
    name: "posted-items",
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        RealignmentItems,
        RawData,
    },
    data(){
        return {
            tableData: [],
            filter: "",
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            currentPage: 1,
            approveLoading: false,
        }
    },
    computed: {
        filteredData() {
            let data = this.tableData;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
    },
    methods: {
        async getData(cycle, deliveryUnitId){
            this.approveLoading = true;
            await this.$store
                .dispatch("realignmentrequest/GetApprovedRealignmentDU", {cycle, deliveryUnitId})
                .then((res) => {
                    res.data.map((x) => {
                        x.viewItems = false;
                        x.realignmentItems = [];
                        x.accounts = [];
                    });
                    this.tableData = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            this.approveLoading = false;
        },
        viewItems(row){
            row.viewItems = !row.viewItems;
            if(row.viewItems && !row.realignmentItems.length > 0){
                this.$store
                    .dispatch("realignmentrequestitem/GetRealignmentItem", row.id)
                    .then((response) => {
                        if (response.data.error) {
                            return this.showToast(response.data.errorMessage, "error");
                        }
                        
                        let group = [];
                        response.data.map(item => {
                            item.totalQ1 = 0;
                            item.totalQ2 = 0;
                            item.totalQ3 = 0;
                            item.totalQ4 = 0;
                            item.realignmentRequestItems.map(x => {
                                if(x.apiResourceDetail.month.quarter == 1){
                                    item.totalQ1 += x.total;
                                }
                                if(x.apiResourceDetail.month.quarter == 2){
                                    item.totalQ2 += x.total;
                                }
                                if(x.apiResourceDetail.month.quarter == 3){
                                    item.totalQ3 += x.total;
                                }
                                if(x.apiResourceDetail.month.quarter == 4){
                                    item.totalQ4 += x.total;
                                }
                            })
                            item.apiName = item.api.name;
                            item.groupName = item.apiResource.deliveryUnitBudgetItem.objectOfExpenditure.accountGroup.groupName;
                            item.groupId = item.apiResource.deliveryUnitBudgetItem.objectOfExpenditure.accountGroup.id;
                            item.fundSource = item.apiResource.deliveryUnitBudgetItem.objectOfExpenditure.fundSource.shortName;
                        })
                        let groupByApi = groupBy(response.data, 'apiId');
                        for(let key in groupByApi){
                            let groupByAccount = groupBy(groupByApi[key], 'groupId');
                            let gAcc = [];
                            let q1 = 0;
                            let q2 = 0;
                            let q3 = 0;
                            let q4 = 0;
                            let total = 0;
                            for(let g in groupByAccount){
                                let totalAQ1 = 0;
                                let totalAQ2 = 0;
                                let totalAQ3 = 0;
                                let totalAQ4 = 0;
                                let totalA = 0;
                                groupByAccount[g].map(a => {
                                    totalA += parseFloat(a.total);
                                    totalAQ1 += parseFloat(a.totalQ1);
                                    totalAQ2 += parseFloat(a.totalQ2);
                                    totalAQ3 += parseFloat(a.totalQ3);
                                    totalAQ4 += parseFloat(a.totalQ4);
                                    q1 += parseFloat(a.totalQ1);
                                    q2 += parseFloat(a.totalQ2);
                                    q3 += parseFloat(a.totalQ3);
                                    q4 += parseFloat(a.totalQ4);
                                    total += parseFloat(a.total);
                                })
                                gAcc.push({
                                    accountId: groupByAccount[g][0].groupId,
                                    account: groupByAccount[g][0].groupName,
                                    fundSource: groupByAccount[g][0].fundSource,
                                    total: totalA,
                                    totalQ1: totalAQ1,
                                    totalQ2: totalAQ2,
                                    totalQ3: totalAQ3,
                                    totalQ4: totalAQ4,
                                    items: groupByAccount[g]
                                })
                            }
                            group.push({
                                api: groupByApi[key][0].apiName,
                                apiId: groupByApi[key][0].apiId,
                                accounts: gAcc,
                                q1: q1,
                                q2: q2,
                                q3: q3,
                                q4: q4,
                                total: total,
                            })
                        }
                        row.isLoading = false;
                        row.realignmentItems = group;
                    })
                    .catch((error) => {
                        console.log(error)
                        row.isLoading = false;
                        this.showToast("Cannot fetch requested items", "error");
                    });

                    this.$store
                    .dispatch("realignmentaccount/GetAllRealignmentAccount", row.id)
                    .then((response) => {
                        if (response.data.error) {
                            return this.showToast(response.data.errorMessage, "error");
                        }
                        response.data.map(item => {
                            item.fGrpAcc = item.accountGroup.toLowerCase().replace(/\s/g,'');
                        })
                        let grpAcc = [];
                        var grp = groupBy(response.data, 'fGrpAcc');
                        for(var key in grp){
                            var q1 = grp[key].reduce((pv, cv) => {
                                return parseFloat(pv) + parseFloat(cv.q1);
                            }, 0);
                            var q2 = grp[key].reduce((pv, cv) => {
                                return parseFloat(pv) + parseFloat(cv.q2);
                            }, 0);
                            var q3 = grp[key].reduce((pv, cv) => {
                                return parseFloat(pv) + parseFloat(cv.q3);
                            }, 0);
                            var q4 = grp[key].reduce((pv, cv) => {
                                return parseFloat(pv) + parseFloat(cv.q4);
                            }, 0);
                            var total = grp[key].reduce((pv, cv) => {
                                return parseFloat(pv) + parseFloat(cv.total);
                            }, 0);
                            grpAcc.push({
                                accountGroup: grp[key][0].accountGroup,
                                accountId: grp[key][0].accountId,
                                realignmentRequestId: grp[key][0].realignmentRequestId,
                                q1: q1,
                                q2: q2,
                                q3: q3,
                                q4: q4,
                                total: total
                            })
                        }
                        row.accounts = grpAcc;
                    })
                    .catch((error) => {
                        this.showToast("Cannot fetch requested accounts", "error");
                    });
            }
        },
        printRealignment(id){
            this.$emit("print-realignment", id);
        },
        viewModifItems(items){
            this.$emit("view-modif-items", items)
        },
        viewLogs(realignmentId){
            this.$emit("view-logs", realignmentId);
        },
        undoApproval(realignmentId){
            this.$emit("undo-approval", realignmentId);
        }
    }
};
</script>
<template>
    <div>
        <div class="d-flex justify-content-between align-items-center">
            <label
                class="d-inline-flex align-items-center mb-0 me-1"
            >
                <b-form-input
                    autocomplete="off"
                    v-model.lazy="filter"
                    type="search"
                    placeholder="Search Modification..."
                    class="form-control"
                    style="width: 300px;"
                ></b-form-input>
                <b-form-select
                    class="form-select ms-1 w-25"
                    v-model="perPage"
                    :options="pageOptions"
                ></b-form-select>
            </label>
        </div>
        <div v-if="approveLoading">
            <div
                class="
                    d-flex
                    justify-content-center
                    align-items-center
                "
            >
                <div class="preloader-component me-2">
                    <div class="status">
                        <div
                            class="
                                spinner-chase
                                w-20px
                                h-20px
                            "
                        >
                            <div
                                class="chase-dot"
                            ></div>
                            <div
                                class="chase-dot"
                            ></div>
                            <div
                                class="chase-dot"
                            ></div>
                            <div
                                class="chase-dot"
                            ></div>
                            <div
                                class="chase-dot"
                            ></div>
                            <div
                                class="chase-dot"
                            ></div>
                        </div>
                    </div>
                </div>
                <strong>Loading...</strong>
            </div>
        </div>
        <div v-if="tableData.length == 0 && !approveLoading" class="mt-3">
            <h4>No data found...</h4>
        </div>
        <div class="card mt-3 mb-1 position-relative" v-for="(realignment, index) in filteredData" :key="realignment.id">
            <RawData 
                :data="realignment" 
                v-if="$store.state.decrypt.isAdmin()" 
                placement="left"
            />
            <header role="tab" class="card-header cursor-pointer">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <h6 class="mb-1">
                            <div class="d-flex align-items-center">
                                <div
                                    style="
                                        min-width: 30px;
                                    "
                                    class="
                                        bg-success
                                        bg-gradient
                                        text-center
                                        me-2
                                        py-1
                                        position-relative
                                    "
                                >
                                    {{index + 1}}
                                </div>
                                <div>
                                    <a href="javascript: void(0);" class="text-dark mb-0" @click="viewItems(realignment)">
                                        {{realignment.description}}
                                    </a>
                                    <div>
                                        <small><a href="javascript:void(0);" @click="printRealignment(realignment.id)"><i class="bx bx-printer"></i>Print Modification</a></small>
                                        <span class="mx-2">|</span>
                                        <small><a href="javascript:void(0);" @click="viewLogs(realignment.id)" class="text-green"><i class="bx bx-receipt"></i>View Logs</a></small>
                                        <template v-if="$store.state.decrypt.isAdmin()">
                                            <span class="mx-2">|</span>
                                        <small><a href="javascript:void(0);" @click="undoApproval(realignment.id)" class="text-green"><i class="bx bx-return"></i>Undo Approval</a></small>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </h6>
                    </div>
                    <div class="d-flex align-items-center">
                        <div>
                            <span class="d-flex align-items-center" @click="viewItems(realignment)"
                                ><small>Click here to {{ realignment.viewItems ? 'minimize' : 'expand'}}</small
                                ><i
                                    class="bx bx-chevron-right rotate font-size-18 ms-3" :class="realignment.viewItems ? 'rotate-90' : 'rotate-0'"
                                ></i
                            ></span>
                        </div>
                    </div>
                </div>
            </header>
            <b-collapse
                :accordion="`savings-accordion-${realignment.id}`"
                role="tabpanel"
                :visible="realignment.viewItems"
            >
                <div class="card-body">
                    <RealignmentItems 
                        :items="realignment.realignmentItems"
                        :record="realignment"
                        :api="realignment.api"
                        :accounts="realignment.accounts"
                        :tableBusy="false" 
                        @view-items="viewModifItems"
                    />
                    <!-- <div v-for="x in realignment.realignmentItems" :key="`resourceList-z${x.id}`" class="ms-3 mb-1 p-3 broken-border" >
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex">
                                <div class="d-flex align-items-center">
                                    <div class="font-size-20 text-yellow">
                                        {{x.totalQty}} {{x.unit && x.unit.shortName}}
                                    </div>
                                    <i class="bx bx-x font-size-20 me-2 text-yellow"></i>
                                </div>
                                <div>
                                    <div>
                                        {{x.apiResource.itemName}}
                                        <div>
                                            <small>{{x.apiResource.description}}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <div class="font-size-20 text-yellow mb-0">
                                    {{formatCurrency(x.total)}}
                                </div>
                                <div>
                                    <small>
                                        ({{formatCurrency(x.apiResource.unitCost)}})
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </b-collapse>
        </div>
    </div>
</template>